import { TriggerType } from '../Model/TriggerType';
import { TriggerAction } from '../Model/TriggerAction';
import { TriggerWithTimeout } from '../Trigger/TriggerWithTimeout';
import { TriggerPageOpenStrategy } from '../Trigger/TriggerWithTimeout/TriggerPageOpenStrategy';
import { TriggerPageLeaveStrategy } from '../Trigger/TriggerWithTimeout/TriggerPageLeaveStrategy';
var TriggerFactory = /** @class */ (function () {
    function TriggerFactory() {
    }
    TriggerFactory.build = function (widget, model) {
        switch (model.type) {
            case TriggerType.Timeout:
                switch (model.action) {
                    case TriggerAction.PageOpen:
                        return new TriggerWithTimeout(widget, model, new TriggerPageOpenStrategy());
                    case TriggerAction.PageLeave:
                        return new TriggerWithTimeout(widget, model, new TriggerPageLeaveStrategy());
                    default:
                        return null;
                }
            default:
                return null;
        }
    };
    return TriggerFactory;
}());
export { TriggerFactory };
